<template>
    <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div :class="elementClasses(classes('classes'), classes('customClasses'))">
      <CodeEditor v-show="! previewMode" :value="content.code" @input="updateContentProperty('code', $event)"/>  
      <div v-show="previewMode" v-html="content.code"></div>
    </div>
  </div>
</template>

<script>
  import CodeEditor from './CodeEditor'
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    components: { CodeEditor },
  })
</script>